import {createContext, ReactNode, useContext, useState} from "react"
import {useLocalStorage} from "../hooks/useLocalStorage"
import * as React from "react";


type ShoppingCartProviderProps = {
  children: ReactNode
}

export type CartItem = {
  id: number
  description: string
  stockcode: string
  quantity: number
  price: number
  state: string[]
}

export type Product = {
  ID: number
  STOCKCODE: string
  DESCRIPTION: string
  SELLPRICE: number
  STATE: string[]
}

type ShoppingCartContextType = {
  openCart: () => void
  closeCart: () => void
  setCartItems: any
  getItemQuantity: (id: number) => number
  increaseCartQuantity: (id: number) => void
  decreaseCartQuantity: (id: number) => void
  removeFromCart: (id: number) => void
  cartQuantity: number
  cartItems: CartItem[]
  setProducts: any
  products: Product[]
  isOpen: boolean
}

const ShoppingCartContext = createContext({} as ShoppingCartContextType)

export function useShoppingCart() {
  return useContext(ShoppingCartContext)
}

export function ShoppingCartProvider({children}: ShoppingCartProviderProps) {

  const [products, setProducts] = useState<Product[]>([]);
  const [isOpen, setIsOpen] = useState(false)
  const [cartItems, setCartItems] = useLocalStorage<CartItem[]>(
    "istore-cart",
    []
  );


  const cartQuantity = cartItems.reduce(
    (quantity, item) => item.quantity + quantity,
    0
  );

  const openCart = () => {
    cartItems.sort((a, b) => b.price * b.quantity - a.price * a.quantity);
    setIsOpen(true)
  }

  const closeCart = () => setIsOpen(false)


  function getItemQuantity(id: number) {
    return cartItems.find(item => item.id === id)?.quantity || 0
  }


  function increaseCartQuantity(id: number) {

    const productItem = products.find(item => String(item.ID) === String(id)) as Product;

    if (!productItem) {
      return;
    }

    setCartItems(currItems => {

      const cartItem = currItems.find(item => item.id === id);

      if (cartItem == null) {

        return [...currItems, {
          id,
          quantity: 1,
          description: productItem.DESCRIPTION,
          stockcode: productItem.STOCKCODE,
          price: productItem.SELLPRICE,
          state: productItem.STATE ?? []
        }]

      } else {

        return currItems.map(item => {
          if (item.id === id) {
            return {
              ...item,
              quantity: item.quantity + 1
            }
          } else {
            return item
          }
        })
      }


    })


  }

  function decreaseCartQuantity(id: number) {

    setCartItems(currItems => {
      if (currItems.find(item => item.id === id)?.quantity === 1) {
        return currItems.filter(item => item.id !== id)
      } else {
        return currItems.map(item => {
          if (item.id === id) {
            return {...item, quantity: item.quantity - 1}
          } else {
            return item
          }
        })
      }
    })

  }

  function removeFromCart(id: number) {
    setCartItems(currItems => {
      return currItems.filter(item => item.id !== id)
    })
  }

  return (
    <ShoppingCartContext.Provider
      value={{
        getItemQuantity,
        increaseCartQuantity,
        decreaseCartQuantity,
        setCartItems,
        removeFromCart,
        openCart,
        isOpen,
        closeCart,
        cartItems,
        cartQuantity,
        setProducts,
        products
      }}
    >
      {children}
    </ShoppingCartContext.Provider>
  )
}